const esc = (v) => String(v ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

function sheet(s, names, codes) {
  const r = s.relay || {};
  const products = (s.products || []).map((slug) => `<li>${esc(names[slug] || slug)}</li>`).join("");
  return `<section class="sheet">
    <header><div class="brand">OZENTYA</div><div>Fiche d'expédition ambassadeur · ${esc(s.month)}</div></header>
    <h1>${esc(s.ambassador_name)}</h1>
    <p class="status">Statut : ${esc(s.status)}${codes[s.email] ? ` · Code promo : <b>${esc(codes[s.email])}</b>` : ""}</p>
    <div class="grid">
      <div class="box"><h2>Destinataire (retrait)</h2>
        <p><b>${esc(s.name)}</b></p><p>Tél. : ${esc(s.phone)}</p><p>Email : ${esc(s.contact_email || s.email)}</p></div>
      <div class="box"><h2>Point Mondial Relay</h2>
        ${s.relay ? `<p><b>${esc(r.kind === "locker" ? "Locker" : "Point Relais")} n° ${esc(r.id)}</b></p><p>${esc(r.name)}</p><p>${esc(r.address)}</p><p>${esc(r.zip)} ${esc(r.city)}${r.country ? ` · ${esc(r.country)}` : ""}</p>`
          : `<p>Adresse : ${esc(s.address)}, ${esc(s.zip)} ${esc(s.city)}</p>`}</div>
    </div>
    <div class="box"><h2>Produits offerts à préparer</h2><ol>${products}</ol></div>
    <div class="check"><span>☐ Colis préparé</span><span>☐ Étiquette Mondial Relay</span><span>☐ Expédié le : ____ / ____ / ______</span></div>
  </section>`;
}

const CSS = `*{box-sizing:border-box}body{font-family:Arial,sans-serif;color:#141013;margin:0}
.sheet{padding:18mm 16mm;page-break-after:always}.sheet:last-child{page-break-after:auto}
header{display:flex;justify-content:space-between;align-items:center;border-bottom:2px solid #B8893A;padding-bottom:8px;font-size:12px;color:#5E544D}
.brand{font-family:Georgia,serif;letter-spacing:6px;font-size:18px;color:#4A1942}
h1{font-family:Georgia,serif;font-weight:normal;font-size:26px;margin:18px 0 4px}.status{margin:0 0 16px;font-size:13px;color:#5E544D}
.grid{display:grid;grid-template-columns:1fr 1fr;gap:12px}.box{border:1px solid #D9C8B3;border-radius:6px;padding:12px 14px;margin-bottom:12px}
h2{font-size:12px;text-transform:uppercase;letter-spacing:2px;color:#7A5418;margin:0 0 8px}p{margin:3px 0;font-size:14px}ol{margin:0;padding-left:20px;font-size:15px;line-height:1.8}
.check{display:flex;gap:24px;flex-wrap:wrap;margin-top:16px;font-size:14px}@page{size:A4;margin:0}`;

/** Opens a clean white A4 print view (one page per ambassador) and launches the browser print dialog. */
export function printSelections(list, names = {}, codes = {}) {
  const w = window.open("", "_blank");
  if (!w) return false;
  w.document.write(`<!doctype html><html lang="fr"><head><meta charset="utf-8"><title>Fiches ambassadeurs Ozentya</title><style>${CSS}</style></head><body>${list.map((s) => sheet(s, names, codes)).join("")}</body></html>`);
  w.document.close();
  w.focus();
  setTimeout(() => w.print(), 300);
  return true;
}
